import { render, staticRenderFns } from "./ToolSection.vue?vue&type=template&id=45afbd0d&scoped=true&"
import script from "./ToolSection.vue?vue&type=script&lang=js&"
export * from "./ToolSection.vue?vue&type=script&lang=js&"
import style0 from "./ToolSection.vue?vue&type=style&index=0&id=45afbd0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45afbd0d",
  null
  
)

export default component.exports